import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterCategoriasCardapio,
    obterProdutosMaisVendidos,
    type FiltroMaisVendidos,
} from "../../../services/listarProdutos"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ListarProdutosInicial } from "../models/listarProdutosModel"
import { ListarProdutosActionsTypes } from "./listarProdutosActions"
import { ListarProdutosContext } from "./ListarProdutosContext"
import { listarProdutosReducer } from "./listarProdutosReducer"

export function ListarProdutosContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(listarProdutosReducer, ListarProdutosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    useEffect(() => {
        const carregarCategorias = async () => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                const response = await obterCategoriasCardapio(autorizacao)
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar categorias")
                } else {
                    dispatch({
                        type: ListarProdutosActionsTypes.CARREGAR_CATEGORIAS,
                        payload: response,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar categorias")
            }
        }
        carregarCategorias()
    }, [])

    const pesquisar = useCallback(
        async (filtro: FiltroMaisVendidos) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                setErroCarregamento(null)
                const response = await obterProdutosMaisVendidos(autorizacao, filtro)
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao pesquisar")
                } else {
                    dispatch({
                        type: ListarProdutosActionsTypes.CARREGAR_RESULTADO,
                        payload: response.pontos,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao pesquisar")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    return (
        <ListarProdutosContext.Provider value={{ dados, dispatch, erroCarregamento, pesquisar }}>
            <Loading />
            {children}
        </ListarProdutosContext.Provider>
    )
}
